
import { Box, TextField, Typography } from '@mui/material';
import { RESOLUTION_2275_2023 } from 'pages/read-documents/helper';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { apiInstance, Dispatch, GET_ELECTRONIC_DOCS, RootState } from 'shared';
import { CustomFileUploader } from 'shared/components';
import Swal from 'sweetalert2';
import { downloadDocument } from '../../utils/helpers/downloadDocument';
import { downloadsDescription, downloadsTitle } from 'shared/utils';
import { ModalLoadRipsFiles } from 'pages/read-documents/components/ModalLoadRipsFiles';

interface propuseModalLoadRipsFiles{
    title: string,
    idDocument: string,
    onAction?: (prevState: any) => void
}

export const useModalLoadRipsFiles = () => {

    const dispatch = useDispatch<Dispatch>();
    const { id, nameNewsRips } = useSelector((state: RootState) => state.linkDocument);
    const { url, paramsUrl } = useSelector((state: RootState) => state.electronicDocuments);

    const [ resolution2275Document, setResolution2275Document ] = useState<any>(null);
    const [ propsModal, setPropsModal ] = useState<propuseModalLoadRipsFiles>({
        title: '',
        idDocument: ''
    });
    const [isLoading, setIsLoading] = useState(false)
    const [callShowModal, setCallShowModal] = useState(false)

    useEffect(() => {
        (nameNewsRips && callShowModal) && showModal({ title: propsModal.title, idDocument: propsModal.idDocument})
    }, [nameNewsRips, callShowModal]); 

    const removeFile = () => {
        setResolution2275Document(null);
        dispatch.linkDocument.cleanStateNameNewsRips();
    }

    const handleChangeFile = (file: any, typeResolution: string, idDocument: string) => {
        setIsLoading(true);
        if (file && file.size < (5000000) && file.name.split('.').pop() === "json" && typeResolution === RESOLUTION_2275_2023) {
            setResolution2275Document(file);
            getLink(file, typeResolution, idDocument)
        }
    };

    const getLink = async(file:any, typeResolution: string, idDocument: string ) => {
        dispatch.linkDocument.getLinkAsync({
          file: file, 
          url: `${GET_ELECTRONIC_DOCS}/${idDocument}/rips/generate-upload-link`,
          typeResolution
        })
        ?.then(() => setIsLoading(false))
        .catch((error) => setResolution2275Document(null) )
        .finally(()=> {
            setCallShowModal(true);
            setIsLoading(false);
        });
      }

    const showModal = ({title,  idDocument, relatedInvoiceNumber}: any) => {
        propsModal.idDocument === '' && setPropsModal({title, idDocument})

        dispatch.messageModal.setMessageModal({
            show: true, 
            title: `Cargar RIPS ${title}`,
            size: 'medium',
            description: (
               <ModalLoadRipsFiles
                   relatedInvoiceNumber={relatedInvoiceNumber}
                   nameNewsRips={nameNewsRips}
                   resolution2275Document={resolution2275Document}
                   handleChangeFile={handleChangeFile}
                   validateDownload={validateDownload}
                   removeFile={removeFile}
                   idDocument={idDocument}
                   closeModal={closeModal}
               />
            ),
            onClose() { closeModal()}
        })
    }

    const validateDownload = (valueCuv: string, idDocument: string) => {
        if(valueCuv){ 
            postRips(valueCuv, idDocument) 
            return
        }
        showAlert('error', 'Debe ingresar un CUV');
    }

    const postRips = async(valueCuv: string, idDocument: string) => {
        setIsLoading(true)
        await apiInstance.post(`${GET_ELECTRONIC_DOCS}/${idDocument}/rips`, {
          attachmentId: id,
          typeResolution: RESOLUTION_2275_2023,
          validationUniqueCode: valueCuv
        })?.then((response) => {
            closeModal();
            validateResponse(response);
            dispatch.electronicDocuments.getElectronicDocuments( paramsUrl, url );
        })
        .catch((error) => removeFile())
        .finally(()=> {
            closeModal()
            setIsLoading(false)
        });
    }

    const closeModal = () => {
        dispatch.messageModal.cleanStateMessage()
        dispatch.linkDocument.cleanState();
        dispatch.linkDocument.cleanStateNameNewsRips();
        setPropsModal({title: '', idDocument: ''});
    }

    const showAlert = (icono: 'error' | 'warning' | 'success', text: string) => {
        Swal.fire({
            title: text,
            icon: icono,
            timer: 5000,
            confirmButtonText: "Aceptar",
        });
    }

    const validateResponse = (responseRips: any) => {
        if(responseRips?.status === 206){
            downloadDocument(responseRips, downloadsTitle.notificationRips, downloadsDescription.notificationRips, 'success');
        } else {
            showAlert('success', 'Se realizó la carga con éxito')
        }
    }

    return{
        showModal,
        removeFile,
        validateResponse,
        validateDownload,
        isLoading
    }
}
